import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

// Common page container
export const PageContainer = styled.div`
  padding: 2rem;
  height: calc(100vh - 4rem);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  background: white;
`;

// Page header section
export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #ccc;
  background: white;
`;

export const Footer = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  overflow-y: auto;
  background: white;
`;

export const PageTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const PageTitle = styled.h1`
  font-size: 1.8rem;
  font-weight: 700;
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: 'Orbitron', sans-serif;
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const InfoIconContainer = styled.div`
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--primary);
  color: white;
  font-size: 14px;
  transition: all 0.2s ease;
  opacity: 0.8;

  &:hover {
    opacity: 1;
    transform: scale(1.1);
  }
`;

export const PageIcon = styled.span`
  font-size: 25px;
  color: var(--primary);
  // font-family: 'Orbitron', sans-serif;
`;

export const PageDescription = styled(motion.p)`
  font-size: 1rem;
  color: var(--text-secondary);
  // margin-bottom: 2rem;
  max-width: 90%;
  line-height: 1.6;
  overflow: hidden;
`;

// Cards and content containers
export const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
`;

export const ContentRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-bottom: 2rem;
`;
export const FloatingCard = styled(motion.div)`
  padding:1rem;
  width:70%;
  border:1px solid rgba(13, 13, 13, 0.05);
  border-radius:25px;
  box-shadow:rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.1) 0px 4px 6px -4px;

`;

// List Components
export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  overflow-y: auto;
  max-height: ${props => props.maxHeight || 'none'};
`;

export const ListItem = styled.div`
  padding: 0.75rem;
  border-radius: 0.5rem;
  background: ${props => props.highlighted ? '#f1f5f9' : 'transparent'};
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f1f5f9;
  }
`;

export const ListItemIcon = styled.div`
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.bg || '#e2e8f0'};
  color: ${props => props.color || '#64748b'};
  font-size: 1rem;
`;

export const ListItemContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const ListItemTitle = styled.div`
  font-weight: 500;
  font-size:0.8rem;
  color: #334155;
`;

export const ListItemDescription = styled.div`
  font-size: 0.875rem;
  color: #64748b;
`;

export const ListItemMeta = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
`;

export const ListItemTime = styled.div`
  font-size: 0.75rem;
  color: #94a3b8;
`;

export const ListItemStatus = styled.div`
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0.25rem 0.5rem;
  border-radius: 1rem;
  background: ${props => {
    switch (props.status) {
      case 'critical': return '#fee2e2';
      case 'warning': return '#fef3c7';
      case 'success': return '#dcfce7';
      default: return '#e2e8f0';
    }
  }};
  color: ${props => {
    switch (props.status) {
      case 'critical': return '#ef4444';
      case 'warning': return '#f59e0b';
      case 'success': return '#10b981';
      default: return '#64748b';
    }
  }};
`;
export const CollapsibleSidebar = styled(motion.div)`

`;

export const Card = styled(motion.div)`
  background: white;
  border: 1px solid #ccc;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
  &.INACTIVE{
    background-color: var(--tw-gray-100);
  }
  &::before {
    content: '';
    position: absolute;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    background: var(--primary);
    filter: blur(80px);
    opacity: 0.05;
    top: -50px;
    right: -50px;
  }
`;

export const CardTitle = styled.div`
    display: flex;
    gap: 1rem;
    flex-direction: row;
    align-items: center;
    h5{
        font-size: 1.2rem;
        font-family: 'Orbitron', sans-serif;
    }
    p{
    font-size: 0.8rem;
    font-family: 'Inter', sans-serif;
    }
`;

export const CardContent = styled.div`
  color: var(--text-secondary);
  font-size: 0.9rem;
  line-height: 1.5;
  padding: 1rem;
`;

// Stats and metrics
export const StatCard = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 1.5rem;
  min-height: 150px;
`;

export const StatValue = styled.div`
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--primary);
  margin-bottom: 0.5rem;
`;

export const StatLabel = styled.div`
  font-size: 0.9rem;
  color: var(--text-secondary);
`;

// Action buttons and controls
export const ActionBar = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const Button = styled.button`
  background: ${props => props.primary ? 'var(--primary)' : 'white'};
  color: ${props => props.primary ? 'white' : 'var(--primary)'};
  border: 1px solid ${props => props.primary ? 'transparent' : 'var(--primary)'};
  border-radius: 8px;
  padding: 0.6rem 1rem;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s ease;
  
  &:hover {
    background: ${props => props.primary ? 'var(--primary-dark)' : 'rgba(0, 102, 255, 0.05)'};
  }
`;

export const PipelineButtons = styled.button`
  background: ${props => props.primary ? 'var(--primary)' : 'white'};
  color: ${props => props.primary ? 'white' : 'var(--primary)'};
  border: 1px solid ${props => props.primary ? 'transparent' : 'var(--primary)'};
  border-radius: 8px;
  padding: 0.6rem 1rem;
  font-size: 1.1rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s ease;
  height: 50px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background: ${props => props.primary ? 'var(--primary-dark)' : 'rgba(0, 102, 255, 0.05)'};
  }
`;

export const SearchInput = styled.input`
  padding: 0.6rem 1rem;
  border-radius: 8px;
  border: 1px solid rgba(0, 102, 255, 0.2);
  width: 300px;
  font-size: 0.9rem;
  
  &:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 2px rgba(0, 102, 255, 0.1);
  }
`;

// Tables
export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 2rem;
  background: white;
`;

export const TableHeader = styled.th`
  text-align: left;
  padding: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  border-bottom: 1px solid #ccc;
  background: white;
  text-transform:capitalize
`;

export const TableRow = styled.tr`
  &:hover {
    background: rgba(0, 102, 255, 0.02);
  }
`;

export const TableCell = styled.td`
  padding: .5rem .8rem;
  border-bottom: 1px solid #ccc;
  color: var(--text-secondary);
`;

// Status indicators
export const StatusBadge = styled.span`
  display: inline-block;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;
  background: ${props => {
    if (props.status === 'active') return 'rgba(40, 167, 69, 0.1)';
    if (props.status === 'inactive') return 'rgba(220, 53, 69, 0.1)';
    if (props.status === 'warning') return 'rgba(255, 193, 7, 0.1)';
    return 'rgba(0, 102, 255, 0.1)';
  }};
  color: ${props => {
    if (props.status === 'active') return '#34C759';
    if (props.status === 'inactive') return '#FF3B30';
    if (props.status === 'warning') return '#FFCC00';
    return 'var(--primary)';
  }};
`;
export const MarkdownContainer = styled.div`
  padding: 1.5rem;
  background: #ffffff;
  border-radius: 0.75rem;
  margin-bottom: 1.5rem;
  max-height: 600px;
  overflow-y: auto;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  line-height: 1.6;
  color: #1a202c;
  
  /* Header styles */
  h1 {
    font-size: 1.875rem;
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 1rem;
    color: #2d3748;
    border-bottom: 1px solid #edf2f7;
    padding-bottom: 0.5rem;
  }
  
  h2 {
    font-size: 1.5rem;
    font-weight: 600;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
    color: #2d3748;
  }
  
  h3 {
    font-size: 1.25rem;
    font-weight: 600;
    margin-top: 1.5rem;
    margin-bottom: 0.75rem;
    color: #4a5568;
  }
  
  h4 {
    font-size: 1.125rem;
    font-weight: 600;
    margin-top: 1.5rem;
    margin-bottom: 0.75rem;
    color: #4a5568;
  }
  
  /* Paragraph and text */
  p {
    margin-top: 0;
    margin-bottom: 1rem;
  }
  
  strong {
    font-weight: 600;
  }
  
  /* List styles */
  ul, ol {
  background: transparent;
    padding-left: 1.75rem;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }
  
  li {
  background: transparent;
    margin-bottom: 0.5rem;
  }
  
  li:last-child {
    margin-bottom: 0;
  }
  
  /* Table styles */
  table {
    border-collapse: separate;
    border-spacing: 0;
    width: 100%;
    margin: 1.5rem 0;
    font-size: 0.875rem;
    border-radius: 0.5rem;
    overflow: hidden;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  
  thead {
    background-color: #f7fafc;
  }
  
  th {
    font-weight: 600;
    text-align: left;
    padding: 0.75rem 1rem;
    border-bottom: 1px solid #e2e8f0;
    color: #4a5568;
    text-transform: capitalize;
  }
  
  td {
    padding: 0.75rem 1rem;
    border-bottom: 1px solid #e2e8f0;
    color: #4a5568;
  }
  
  tr:last-child td {
    border-bottom: none;
  }
  
  tr:nth-child(even) {
    background-color: #f7fafc;
  }
  
  /* Horizontal rule */
  hr {
    height: 1px;
    border: none;
    background-color: #e2e8f0;
    margin: 1.5rem 0;
  }
  
  /* Code blocks */
  code {
    background-color: #edf2f7;
    padding: 0.2rem 0.4rem;
    border-radius: 0.25rem;
    font-family: Menlo, Monaco, Consolas, 'Liberation Mono', monospace;
    font-size: 0.875em;
    color: #d53f8c;
  }
  
  pre {
    background-color: #2d3748;
    border-radius: 0.5rem;
    padding: 1rem;
    overflow-x: auto;
    margin: 1rem 0;
  }
  
  pre code {
    background-color: transparent;
    padding: 0;
    color: #e2e8f0;
    font-size: 0.875rem;
  }
  
  /* Blockquote */
  blockquote {
    border-left: 4px solid #4299e1;
    padding: 0.75rem 1rem;
    margin: 1.5rem 0;
    background-color: #ebf8ff;
    color: #2c5282;
    font-style: italic;
    border-radius: 0 0.25rem 0.25rem 0;
  }
  
  /* Links */
  a {
    color: #4299e1;
    text-decoration: underline;
    transition: color 0.2s;
  }
  
  a:hover {
    color: #2b6cb0;
  }
  
  /* Focus for accessibility */
  *:focus {
    outline: 2px solid #4299e1;
    outline-offset: 2px;
  }
  
  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f7fafc;
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: #cbd5e0;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background-color: #a0aec0;
  }
`;
// Charts and visualizations
export const ChartContainer = styled.div`
  width: 100%;
  height: 300px;
  margin-bottom: 2rem;
  background: white;
  border: 1px solid #ccc;
  border-radius: 16px;
  padding: 1rem;
`;

// Tabs
export const TabContainer = styled.div`
  margin-bottom: 2rem;
  background: white;
`;

export const TabList = styled.div`
  display: flex;
  border-bottom: 1px solid #ccc;
  margin-bottom: 1.5rem;
  background: white;
`;

export const Tab = styled.div`
  padding: 0.8rem 1.5rem;
  cursor: pointer;
  color: ${props => props.active ? 'var(--primary)' : 'var(--text-secondary)'};
  font-weight: ${props => props.active ? '600' : '400'};
  border-bottom: ${props => props.active ? '2px solid var(--primary)' : '2px solid transparent'};
  
  &:hover {
    color: var(--primary);
  }
`;

export const TabContent = styled.div`
  display: ${props => props.active ? 'block' : 'none'};
`;

// Agentic AI specific components
export const AgentCard = styled(Card)`
  display: flex;
  flex-direction: column;
  min-height: 200px;
`;

export const AgentHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const AgentAvatar = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 12px;
  background: rgba(0, 102, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
`;
export const QueryBadge = styled.div`
    position: absolute;
    top: -10px;
    font-size: .8rem;
    right: -10px;
    height: 20px;
    background-color: #f44444;
    color: #fff;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 3px;
`;
export const AgentInfo = styled.div`
  flex: 1;
`;

export const AgentName = styled.div`
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 0.2rem;
`;

export const AgentType = styled.div`
  font-size: 0.8rem;
  color: var(--text-secondary);
`;

export const AgentMetrics = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  padding-top: 1rem;
  border-top: 1px solid #ccc;
`;
export const Tooltip = styled.div`
  visibility: hidden;
  background: #222;
  color: #fff;
  text-align: center;
  border-radius: 4px;
  padding: 0.4em 0.8em;
  position: absolute;
  z-index: 10;
  bottom: 120%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.2s;
  font-size: 0.85rem;
  pointer-events: none;
`;

export const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
  &:hover ${Tooltip} {
    visibility: visible;
    opacity: 1;
  }
`;
export const AgentMetric = styled.div`
  text-align: center;
`;

export const MetricValue = styled.div`
  font-weight: 600;
  color: var(--text-primary);
`;

export const MetricLabel = styled.div`
  font-size: 0.7rem;
  color: var(--text-secondary);
`;

// Knowledge components
export const KnowledgeCard = styled(Card)`
  display: flex;
  flex-direction: column;
  min-height: 180px;
`;

export const KnowledgeIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(0, 102, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  margin-bottom: 1rem;
  color: var(--primary);
`;
// FORM Components
export const FormGroup = styled.div`
  position: relative;
  margin-bottom: 1.5rem;
`;

export const TableFormGroup = styled.div`
  margin-bottom: 2px;
  margin-top: 2px;
`;
export const FlexLayout = styled.div`
  display: flex;
  gap: 1rem;
  position:relative;
  height:100%
`;
export const Flex1ThirdLayout = styled.div`
  flex: 1 1 33%;
  transition: all 3s;
`;

export const Flex2ThirdLayout = styled.div`
  flex: 1 1 66%;
`;
export const StrongOrbi = styled.div`
  font-weight:bold;
  font-family: 'Orbitron', sans-serif;
`;
export const StepIndicator = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    top: 18px;
    left: 0;
    width: 100%;
    height: 2px;
    background: rgba(0, 102, 255, 0.1);
    z-index: 0;
  }
`;

export const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 20%;
  z-index: 1;
`;

export const StepCircle = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: ${props => props.active ? 'var(--gradient-primary)' : props.completed ? 'var(--primary)' : 'rgba(0, 102, 255, 0.1)'};
  color: ${props => props.active || props.completed ? '#ffffff' : 'var(--text-secondary)'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  margin-bottom: 0.5rem;
  transition: all 0.3s ease;
  box-shadow: ${props => props.active ? '0 0 15px rgba(0, 102, 255, 0.3)' : 'none'};
`;

export const StepLabel = styled.div`
  font-size: 0.8rem;
  color: ${props => props.active ? 'var(--primary)' : 'var(--text-secondary)'};
  font-weight: ${props => props.active ? '600' : '400'};
  text-align: center;
  transition: all 0.3s ease;
`;
export const InfoBox = styled.div`
  background: rgba(0, 102, 255, 0.05);
  border-left: 3px solid var(--primary);
  padding: 1rem;
  border-radius: 0 8px 8px 0;
  margin-bottom: 1.5rem;
  font-size: 0.9rem;
  color: var(--text-secondary);
`;
export const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  // margin-bottom: 1.5rem;
`;
export const FormRowFull = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  //margin-bottom: 1.5rem;
`;
export const Label = styled.label`
  display: block;
  margin-bottom: 0.3rem;
  font-weight: 600;
  font-size: 0.8rem;
  color: var(--text-primary);
`;
// const Label = styled.label`
//   position: absolute;
//   top: 50%;
//   left: 0.75rem;
//   transform: translateY(-50%);
//   font-size: 1rem;
//   color: #aaa;
//   transition: all 0.2s ease-in-out;
//   pointer-events: none;

//   ${({ isFocused }) =>
//     isFocused &&
//     `
//     top: -0.5rem;
//     left: 0.5rem;
//     font-size: 0.75rem;
//     color: var(--primary);
//   `}
// `;
export const Input = styled.input`
width: 100%;
  padding: 0.6rem 0.5rem;
  background: #ffffff;
  border: 1px solid #0066ff;
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 0.9rem;
  // transition: border-color 0.2s ease-in-out;

  &:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 2px rgba(0, 102, 255, 0.1);
  }
`;
export const TagInputWrapper = styled.div`
  width: 100%;
  padding: 0.6rem 0.5rem;
  background: #ffffff;
  border: 1px solid #0066ff;
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 0.9rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;

  &:focus-within {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 2px rgba(0, 102, 255, 0.1);
  }

  .react-tag-input {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .react-tag-input__tag {
    border: var(--primary);
    color: var(--primary);
    padding: 0.3rem 0.6rem;
    border-radius: 4px;
    font-size: 0.8rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .react-tag-input__tag__remove {
    background: transparent;
    border: none;
    color: #000;
    cursor: pointer;
    font-size: 1rem; /* Adjust size for better visibility */
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .react-tag-input__tag__remove::before{
  content:"x"
  }
  .react-tag-input__input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 0.9rem;
    color: var(--text-primary);
  }
`;
export const ChatInput = styled.input`
  width: 100%;
  padding: 0.6rem 0.5rem;
  background: #ffffff;
  border:none;
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 0.9rem;
  // transition: border-color 0.2s ease-in-out;
  
  &:focus {
    outline: none;
    border-color: var(--primary);
    // box-shadow: 0 0 0 2px rgba(0, 102, 255, 0.1);
  }
`;




export const ChatButtons = styled(motion.button)`
  display:flex;
  justify-content:center;
  align-items:center;
  border-radius:15px;
  min-width:35px;
  height:35px;
  text-align: center;
  cursor: pointer;
  border-style:solid;
  border-width:1px;
  border-color: #0d0d0d1a;
  color: #5d5d5d;
  padding-left:15px;
  padding-right:15px;
  background-color:transparent;
  font-size:0.9rem;
  gap: 0.5rem;

&:hover {
  background:#f2f2f2;
}
&.isActive{
  border-color:black;
  color:black
}
`;




export const FilterBar = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  overflow-x: auto;
  padding-bottom: 0.5rem;
`;

export const FilterButton = styled.button`
  background: ${props => props.primary ? 'var(--primary)' : 'white'};
  color: ${props => props.primary ? 'white' : 'var(--text-primary)'};
  border: 1px solid ${props => props.primary ? 'var(--primary)' : '#e0e0e0'};
  border-radius: 20px;
  padding: 0.4rem 1rem;
  font-size: 0.85rem;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  
  &:hover {
    background: ${props => props.primary ? 'var(--primary)' : 'rgba(0, 102, 255, 0.05)'};
  }
`;

export const Toggle = styled.div`
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
`;

export const ToggleInput = styled.input`
  opacity: 1;
  width: 20px;
  height: 20px;
  
  &:checked + span {
    background: var(--gradient-primary);
  }
  
  &:checked + span:before {
    transform: translateX(24px);
  }
`;

export const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.1);
  transition: 0.4s;
  border-radius: 34px;
  
  &:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }
`;

export const ToggleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  
  &:last-child {
    border-bottom: none;
  }
`;

export const ToggleLabel = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ToggleTitle = styled.div`
  font-weight: 500;
  margin-bottom: 0.3rem;
`;

export const ToggleDescription = styled.div`
  font-size: 0.85rem;
  color: var(--text-secondary);
`;

export const ColorOption = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: ${props => props.color};
  cursor: pointer;
  border: 2px solid ${props => props.selected ? 'white' : 'transparent'};
  transition: all 0.2s ease;
  
  &:hover {
    transform: scale(1.1);
  }
`;

export const ColorOptions = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
`;

export const Select = styled.select`
  width: 100%;
  padding: 0.6rem 0.5rem;
  background: #ffffff;
  border: 1px solid rgba(0, 102, 255, 0.1);
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 0.9rem;
  
  &:focus {
    outline: none;
    border-color: var(--primary);
  }
  
  option {
    background: #ffffff;
    color: var(--text-primary);
  }
`;
export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const Loader = styled.div`
  position: absolute;
  display: flex;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.26);
  z-index: 999;
  color: #fff;
  width: 100%;
  justify-content: center;  
  align-items: center;
`;

export const ModalContent = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 2rem;
  width: 70%;
  max-width: 90%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  height:95dvh;
  overflow-y:auto;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;
export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(0, 102, 255, 0.1);
`;
export const Textarea = styled.textarea`
width: 100%;
padding: 0.8rem 1rem;
background: #ffffff;
border: 1px solid rgba(0, 102, 255, 0.1);
border-radius: 8px;
color: var(--text-primary);
font-size: 0.9rem;
min-height: 120px;
resize: vertical;
transition: all 0.2s ease;

&:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 2px rgba(0, 102, 255, 0.1);
}

&:hover {
  border-color: rgba(0, 102, 255, 0.3);
}
`;
export const CloseButton = styled.button`
  background: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--text-secondary);
`;
export const Divider = styled.div`
  height: 1px;
  background: rgba(0, 0, 0, 0.1);
  margin: 1.5rem 0;
`;
export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
  min-width: 120px;
`;

export const SectionTitle = styled.h2`
font-size: 1.5rem;
font-weight: 600;
margin-bottom: 0rem;
color: var(--text-primary);
font-family: 'Orbitron', sans-serif;
display:flex;
gap:20px;
align-items:center;
`;

export const SubSectionTitle = styled.h2`
font-size: 1.2rem;
font-weight: 600;
margin-bottom: 0rem;
color: var(--text-primary);
font-family: 'Orbitron', sans-serif;
`;

export const ButtonSuccess = styled(motion.button)`
padding: 0.6rem 1rem;
background: #50c850;
border: 1px solid #50c850;
border-radius: 8px;
color: #fff;
font-weight: 600;
font-size: 0.9rem;
cursor: pointer;
min-width: 120px;

&:hover {
  background:#32aa32;
  border-color: #32aa32;
}
`;


export const ChatWrapper = styled(motion.div)`
  padding: 0px 15px;
  width: 100%;
`;
export const ChatScrollContainer = styled(motion.div)`
  height:calc(100dvh - 226px);
  margin-top:40px;
  overflow-y: auto;
  padding-right:10px;
`;
export const ChatBotScrollContainer = styled(motion.div)`
  height: calc(100dvh - 370px);
  overflow-y: auto;
  padding-right: 10px;
  margin-bottom: 15px;
  border-radius: 8px;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }
`;
export const ChatSystemCard = styled(motion.div)`
  & .incoming_msg_img{
    display: inline-block;
    width: 33px;
    background-color: trans;
    border-radius: 50%;
    height: 31px;
    text-align: center;
    padding-top:4px
  }
  & .received_msg {
    display: inline-block;
    padding: 0 0 0 10px;
    vertical-align: top;
    width: 92%;
    & .received_withd_msg{
      min-width: 57%;
      max-width:80%;
      margin-top:10px;
      & .p-15{
        padding: 15px;
        overflow-x:auto;
      }
      & table {
        width: 100%;
        border-collapse: collapse;
      }

      & th,& td {
        border: 1px solid #ddd;
        padding: 8px;
        text-align: left;
      }

      & th {
        background-color: #f4f4f4;
      }
      & p{
          // background: rgb(241, 245, 249) none repeat scroll 0 0;
          border-radius: 0 15px 15px 15px;
          color: #646464;
          font-size: .9rem;
          margin: 0;
          padding: 2px;
          width: 100%;
      }
      & h1{
          color: #000;
          font-size: 18px;
          font-weight:bold;
          margin: 0;
          padding: 5px 10px 5px 12px;
          width: 100%;
      }
      & h2{
          color: #000;
          font-size: 16px;
          font-weight:bold;
          margin: 0;
          padding: 5px 10px 5px 12px;
          width: 100%;
      }
      & h3{
        color: #646464;
        text-decoration:underline;
        font-size: 15px;
        font-weight:bold;
        margin: 0;
        padding: 5px 10px 5px 12px;
        width: 100%;
      }
      & ol, & ul{
        background: transparent none repeat scroll 0 0;
        margin-left:20px;
      }
      & h4{
        border-radius: 0 15px 15px 15px;
        color: #646464;
        text-decoration:underline;
        font-size: 14px;
        font-weight:bold;
        margin: 0;
        padding: 5px 10px 5px 12px;
        width: 100%;
      }
      & .time_date {
          color: #747474;
          display: block;
          font-size: 12px;
          margin: 8px 0 0;
      }
    }
}
`;
export const ChatUserCard = styled(motion.div)`
  overflow: hidden;
  margin: 20px 0 20px;
  & .sent_msg {
    float: right;
    width: 46%;
    & p {
        background: #0465ac;
        border-radius: 12px 15px 15px 0;
        font-size: 14px;
        margin: 0;
        color: #fff;
        padding: 5px 10px 5px 12px;
        width: 100%;
    }
    & h2 {
        background: transparent;
        border-radius: 12px 15px 15px 0;
        font-size: 14px;
        margin: 0;
        color: #fff;
        padding: 5px 10px 5px 12px;
        width: 100%;
    }
    & .time_date {
      color: #747474;
      display: block;
      font-size: 12px;
      margin: 8px 0 0;
    }
  }
`;
export const ChatBottom = styled(motion.div)`
  position: relative;
  display:flex;
  justify-content:center;
`;
// export const ChatWrapper =styled(motion.div)``; 

// Animation variants
export const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 }
};

export const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

export const formatString = (input) => {
  if (!input) return '';

  return input
    .replace(/[_-]/g, ' ') // Replace underscores or hyphens with spaces
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Insert space before capital letters in camelCase
    .toLowerCase() // Convert the entire string to lowercase
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
};

// Utility function to format date
export const formatDate = (isoString) => {
  const date = new Date(isoString);
  return date.toLocaleDateString('en-GB');
};

export const useGoBack = () => {
  const navigate = useNavigate();
  return () => navigate(-1);
};

export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024; // Define the conversion factor
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']; // Units

  const i = Math.floor(Math.log(bytes) / Math.log(k)); // Determine the unit
  const formattedBytes = parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)); // Format the value

  return `${formattedBytes} ${sizes[i]}`; // Return the formatted string
};
